import React from 'react';
import { useSelector } from 'react-redux';
import { Actions } from '../../../store/actions';
import { dispatch } from '../../../utils/utility/store';
import Pagination from '../../components/Pagination';
import ProptechCard from '../../components/ProtechCard';

export default function ForYouTab({ tab }) {
  const { vcForYou, forYouPage, forYouPageSize } = useSelector(state => state.vcForYou);

  // Set page no. in store on page change in pagination
  const handlePageChange = (v) => {
    dispatch(Actions.VCForYou.VCSetPage, v)
  }

  // Set page no. and size in store on page change in pagination
  const handleRowChange = (v) => {
    dispatch(Actions.VCForYou.VCSetPageSize, v)
    dispatch(Actions.VCForYou.VCSetPage, 0)
  }

  return (
    <>
      <div className="proptech-card-wrapper">
        {/* Proptech card */}
        {
          vcForYou?.rows && vcForYou?.rows.length ? vcForYou?.rows.map((proptech) => {
            return (<ProptechCard className="for-you-card" proptech={proptech} key={proptech?.id} tab={tab} />)
          }) : null
        }
      </div>
      {/* Pagination */}
      <div className='flex justify-between items-center'>
        {vcForYou?.count ? <span className='text-sm font-normal'>All values in USD</span> : null}
        {vcForYou?.count ?
          <Pagination
            length={vcForYou?.count}
            tab="Proptechs"
            page={forYouPage}
            size={forYouPageSize}
            handlePageChange={(v) => handlePageChange(v)}
            handleRowChange={(v) => handleRowChange(v)}
          />
          : null}
      </div>
    </>
  )
}